<template>
  <v-dialog v-model="show" :max-width="options.maxWidth" :transition="transition" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable>
    <v-card style="height:600px;">

      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Select Provider</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-circular indeterminate color="white" :size="20" v-show="loadingShare"></v-progress-circular>

      </v-toolbar>
      <v-card column flat>
        <v-text-field ref="input" class="input" prepend-icon="search" placeholder="Provider search" v-model="formInput" solo flat />
        <v-divider></v-divider>
        <v-card-text>
          <provider-card class="mt-3" @click="selectProvider(provider)" v-for="provider in searchResults" :key="provider.npi" :provider="provider">
            <v-layout slot="actions">
              <v-spacer></v-spacer>
              <v-btn depressed @click="selectProvider(provider)" flat color="primary"><span v-show="!loadingShare">select</span></v-btn>
            </v-layout>
          </provider-card>

        </v-card-text>
      </v-card>

      <v-spacer />
    </v-card>
  </v-dialog>
</template>

<style scoped>
.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.standardCard {
  border: 1px solid #e6e6e8;
  background-color: white;
}

.title {
  font-size: 24px;
  font-weight: 300;
  line-height: 1.33;
  text-align: center;
  color: white;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  text-align: center;
  color: #52535f;
}
.input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 8px 16px;
  width: 100%;
  border-radius: 4px;
  font-size: 18px;
  background: white;
}
</style>

<script>
import ProviderCard from '@/components/cards/ProviderCard'
import DialogMixin from '@/core/mixins/DialogMixin'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'OneProviderInfoDialog',
  mixins: [DialogMixin],
  components: {
    ProviderCard
  },
  data() {
    return {
      loadingShare: false,
      formInput: '',
      searchType: { title: 'Individuals', value: 'idv' },
      searchTypes: [
        { title: 'Individuals', value: 'idv' },
        { title: 'Organization', value: 'org' }
      ],
      className: 'Confirm',
      defaultOptions: {
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        showOk: true,
        showCancel: false
      }
    }
  },
  computed: {
    ...mapState('provider', ['searchResults']),
    transition() {
      return this.$vuetify.breakpoint.xsOnly
        ? 'dialog-bottom-transition'
        : 'scale-transition'
    },
    showBuilding() {
      return this.options.unit && this.options.building
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
  },
  methods: {
    ...mapActions('patient', ['getPatient']),
    ...mapActions('provider', ['search', 'getProviderIDFromNPI']),
    selectFilter(filter) {
      this.searchType = filter
    },
    selectProvider(provider) {
      this.loadingShare = true
      this.getProviderIDFromNPI({ npis: [provider.npi] }).then(
        providerReturn => {
          let providerReturned = providerReturn[0]
          const vm = this
          vm.$emit('emitProvider', providerReturned)
          this.loadingShare = false
          vm.formInput = ''
          vm.ok()
        }
      )
    },
    close() {
      this.cancel()
    },
    onOpen() {
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    }
  },
  watch: {
    formInput(val) {
      this.search({ type: 'individual', terms: val })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/ProviderSelectorDialog.vue